module.exports = __webpack_public_path__ + "static/media/teak_with_koto.46f3c900.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/teak_with_koto.jpg
// module id = 39
// module chunks = 0